import { ref } from 'vue'




let loginStatus = ref()  
let cart_Status = ref() 
let orderTotal = ref(0);
let modalCoverage = ref(false);
let showModal = ref(false);

export async function CheckStatus2 ()
{

  var axios = require('axios');
  //var response = "1111";

var config = {
  method: 'get',
maxBodyLength: Infinity,
  url: process.env.VUE_APP_API_EDNPOINT+'/status',
  headers: { 
    'Authorization': 'Bearer ' + localStorage.getItem('tmToken')
  }
};


 await axios(config)
.then(function (response) {
console.log("log: " + response.data)
  loginStatus.value = JSON.stringify(response.data);
return loginStatus

})
.catch(function (error) {
console.log(error);

});

}

// export function CartStatus()
// {
//   let cart = []
//       if( localStorage.getItem('bundleCart'))
//       {
//           cart = JSON.parse(localStorage.getItem('bundleCart'));
//       } 

//       //cartItems.value = cart.length;
    
//       cart_Status.value = cart.length
// }


export function CartTotal(company)
{

  orderTotal.value = 0;

  let cart = []
  if( localStorage.getItem('bundleCart_'+company))
  {
      cart = JSON.parse(localStorage.getItem('bundleCart_'+company));
  } 

    cart.forEach((obj) => {
      orderTotal.value += (Number(obj.quantity) * Number(obj.bundlePrice))
  });
  //console.log("orderTotal: " + orderTotal.value);

}


export function CartStatus(company)
{

  CartTotal(company);

  let cart = []
      if( localStorage.getItem('bundleCart_'+company))
      {
          cart = JSON.parse(localStorage.getItem('bundleCart_'+company));
      } 

      //cartItems.value = cart.length;
    
if(cart.length > 0)
{
  var res = cart.map(bill => bill.quantity).reduce((acc, amount) => Number(acc) + Number(amount));

  //console.log("AQ: " + res);

  cart_Status.value = res



}
else
{
  cart_Status.value = 0
}


}


export  {loginStatus}  
export  {cart_Status} 
export {orderTotal} 
export {modalCoverage}
export {showModal}
//let cartItems = ref(0)








    
  